import { RotateRight } from "@mui/icons-material";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface LightboxRotateButtonProps {
  onRotate: () => void;
  isMobile: boolean;
}

export const LightboxRotateButton = ({
  onRotate,
  isMobile
}: LightboxRotateButtonProps) => {
  const theme = useTheme();

  return (
    <Box
      onClick={onRotate}
      sx={{
        position: "absolute",
        bottom: 0,
        right: 0,
        width: isMobile ? "50px" : "60px",
        height: isMobile ? "50px" : "60px",
        backgroundColor: theme.palette.misc.backdropOverlay,
        borderRadius: "4px",
        zIndex: 30,
        cursor: "pointer",
        WebkitTapHighlightColor: "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "background-color 0.2s ease",
        backdropFilter: "blur(4px)",
        userSelect: "none",
        WebkitUserSelect: "none",
        WebkitTouchCallout: "none",
        "&:hover": {
          backgroundColor: theme.palette.common.black
        }
      }}
      aria-label="Rotate image"
    >
      <RotateRight
        sx={{
          color: theme.palette.common.white,
          fontSize: isMobile
            ? theme.typography.subtitle3.fontSize
            : theme.typography.h4.fontSize
        }}
      />
    </Box>
  );
};
